import Swiper from 'swiper';
import { add_swiper_class } from '@angoulemetourisme/js/tools/swiper';
import Modernizr from "modernizr";

export default class Slider {

	constructor()
	{
		Slider.hero();
		Slider.related_posts();
		Slider.wpetOffer();
	}

	static hero()
	{
		const slider         = '[data-id="wpiris-hero-slider"]',
			slider_wrapper = '[data-id="wpiris-hero-slider-wrapper"]',
			slider_item    = '[data-id="wpiris-hero-slider-item"]',
			slider_effect    = $(slider).data('swiper-effect');

		if ( $( slider ).length > 0 ) {

			add_swiper_class( $( slider ), $( slider_wrapper ), $( slider_item ) );

			let config = {
				mousewheel: {
					forceToAxis: true,
				},
				autoplay: {},
				speed: 1000,
				slidesPerView: 1,
				loop: true,
				lazy: true,
				pagination: {
					el: '[data-trigger="swiper-dots"]',
					clickable: true,
				}
			}

			if( slider_effect ){
				let params = {
					effect : slider_effect
				}

				config = {...config, ...params}
			}

			new Swiper( $( slider ), config );

		}
	}

	static upcomings()
	{
		const slider         = '[data-id="upcomings-slider"]',
			  slider_wrapper = '[data-id="upcomings-slider-wrapper"]',
			  slider_item    = '[data-slider-item]';

		let swiper_openings;

		if ( $( slider ).length > 0 ) {
			$( slider ).each( function () {

				let slider_elements = $( this ).find( slider_item );

				if ( $( slider_elements ).length > 1 ) {

					add_swiper_class( $( slider ), $( slider_wrapper ), $( slider_item ) );

					swiper_openings = new Swiper( $( slider ), {
						mousewheel: {
							forceToAxis: true,
						},
						autoplay: false,
						speed: 600,
						slidesPerView: 1,
						spaceBetween: 20,
						lazy: true,
						navigation: {
							nextEl: '[data-trigger="swiper-next"]',
							prevEl: '[data-trigger="swiper-prev"]',
						},
						breakpoints: {
							0: {
								slidesPerView: 1,
								spaceBetween: 20
							},
							650: {
								slidesPerView: 1,
								spaceBetween: 40
							},
							1000: {
								slidesPerView: 1,
								spaceBetween: 20
							},
						}
					} );
				}
			} );
		}
	}

	static slider_carousel()
	{

		let filter         = '[data-carousel-filter]',
		    slider         = '[data-id="wpiris-carousel"]',
			slider_wrapper = '[data-id="wpiris-carousel-wrapper"]',
			slider_item    = '[data-swiper-carousel-item]';

		if ( $( slider ).length > 0 ) {

			$( filter ).on('click', function(){
				$( filter ).removeClass('is-active');
				$( this ).addClass('is-active');

				let category = $( this ).data( 'carousel-filter' );
				$( '[data-carousel]' ).removeClass('is-active');
				$( '[data-carousel="' + category + '"]' ).addClass('is-active');
			})

			$( slider ).each( function () {

				let slider_elements = $( this ).find( slider_item );

				add_swiper_class( $( this ), $( this ).find( slider_wrapper ), $( this ).find( slider_item ) );

				let config = {
					mousewheel: {
						forceToAxis: true,
					},
					keyboard: true,
					spaceBetween: 20,
					speed: 600,
					lazy: true,
					grabCursor: true,
					slidesPerView: 2,
					centeredSlides: false,
					loop: false,
					pagination: {
						el: '[data-trigger="swiper-dots--carousel"]',
						clickable: true,
					},
				}

				// Desktop mode
				if ( !Modernizr.touchevents ) {
					let desktopConfig = {
						effect : 'coverflow',
						centeredSlides : true,
						loop : true,
						spaceBetween : 100,
						slidesPerView : 2.5,
						coverflowEffect : {
							rotate: 0,
							stretch: 0,
							depth: 280,
							slideShadows: false,
						}
					}

					config = {...config, ...desktopConfig}
				}

				let swiper_carousel = new Swiper( $( this ), config );
			} );
		}
	}

	static slider_blog()
	{
		let slider         = '[data-id="wpiris-slider-blog"]',
			slider_wrapper = '[data-id="wpiris-slider-blog-wrapper"]',
			slider_item    = '[data-slider-item]';

		if ( $( slider ).length > 0 ) {

			$( slider ).each( function () {

				let slider_elements = $( this ).find( slider_item );

				add_swiper_class( $( this ), $( this ).find( slider_wrapper ), $( this ).find( slider_item ) );

				let swiper_related_post = new Swiper( $( this ), {
					mousewheel: {
						forceToAxis: true,
					},
					keyboard: true,
					spaceBetween: 40,
					speed: 600,
					lazy: true,
					slidesPerView: 2.4,
					pagination: {
						el: '[data-trigger="swiper-dots--blog"]',
						clickable: true,
					},
					breakpoints: {
						0: {
							slidesPerView: 1.1,
							spaceBetween: 20
						},
						550: {
							slidesPerView: 1.6,
							spaceBetween: 20
						},
						1000: {
							slidesPerView: 2.4,
							spaceBetween: 20
						},
						1200: {
							slidesPerView: 2.4,
							spaceBetween: 40
						},
					}
				} );
			} );
		}
	}

	static slider_rando()
	{
		let slider         = '[data-id="wpiris-slider-rando"]',
			slider_wrapper = '[data-id="wpiris-slider-rando-wrapper"]',
			slider_item    = '[data-slider-item]';

		if ( $( slider ).length > 0 ) {

			$( slider ).each( function () {

				let slider_elements = $( this ).find( slider_item );

				add_swiper_class( $( this ), $( this ).find( slider_wrapper ), $( this ).find( slider_item ) );

				let swiper_related_post = new Swiper( $( this ), {
					mousewheel: {
						forceToAxis: true,
					},
					keyboard: true,
					spaceBetween: 40,
					speed: 600,
					lazy: true,
					slidesPerView: 2.4,
					pagination: {
						el: '[data-trigger="swiper-dots--rando"]',
						clickable: true,
					},
					breakpoints: {
						0: {
							slidesPerView: 1.1,
							spaceBetween: 20
						},
						650: {
							slidesPerView: 1.6,
							spaceBetween: 20
						},
						1000: {
							slidesPerView: 1.2,
							spaceBetween: 20
						},
						1200: {
							slidesPerView: 1.2,
							spaceBetween: 40
						},
					}
				} );
			} );
		}
	}

	static slider_agenda()
	{
		let slider         = '[data-id="wpiris-slider-agenda"]',
			slider_wrapper = '[data-id="wpiris-slider-agenda-wrapper"]',
			slider_item    = '[data-slider-item]';

		if ( $( slider ).length > 0 ) {

			$( slider ).each( function () {

				let slider_elements = $( this ).find( slider_item );

				add_swiper_class( $( this ), $( this ).find( slider_wrapper ), $( this ).find( slider_item ) );

				let swiper_related_post = new Swiper( $( this ), {
					mousewheel: {
						forceToAxis: true,
					},
					keyboard: true,
					spaceBetween: 20,
					speed: 600,
					lazy: true,
					slidesPerView: 2.15,
					pagination: {
						el: '[data-trigger="swiper-dots--events"]',
						clickable: true,
					},
					breakpoints: {
						0: {
							slidesPerView: 1.1,
							spaceBetween: 20
						},
						550: {
							slidesPerView: 2.1,
							spaceBetween: 20
						},
						650: {
							slidesPerView: 1.1,
							spaceBetween: 20
						},
						1000: {
							slidesPerView: 1.6,
							spaceBetween: 20
						},
						1200: {
							slidesPerView: 2.15,
							spaceBetween: 20
						},
						1400: {
							slidesPerView: 2.15,
							spaceBetween: 40
						},
					}
				} );
			} );
		}
	}

	static slider_temps_forts()
	{
		let slider         = '[data-id="wpiris-slider-temps-forts"]',
			slider_wrapper = '[data-id="wpiris-slider-temps-forts-wrapper"]',
			slider_item    = '[data-slider-item]';

		if ( $( slider ).find(slider_item).length > 1 ) {

			$( slider ).each( function () {

				let slider_elements = $( this ).find( slider_item );

				add_swiper_class( $( this ), $( this ).find( slider_wrapper ), $( this ).find( slider_item ) );

				let swiper_related_post = new Swiper( $( this ), {
					mousewheel: {
						forceToAxis: true,
					},
					keyboard: true,
					spaceBetween: 0,
					speed: 600,
					lazy: true,
					slidesPerView: 1,
					pagination: {
						el: '[data-trigger="swiper-dots--entity"]',
						clickable: true,
					},
					breakpoints: {
						0: {
							slidesPerView: 1,
							spaceBetween: 20
						},
						550: {
							slidesPerView: 1,
							spaceBetween: 0
						}
					}
				} );
			} );
		}
	}

	static related_posts()
	{
		let slider         = '[data-id="wpiris-relatedpost"]',
			slider_wrapper = '[data-id="wpiris-relatedpost-wrapper"]',
			slider_item    = '[data-slider-item]';

		if ( $( slider ).length > 0 ) {

			$( slider ).each( function () {

				add_swiper_class( $( this ), $( this ).find( slider_wrapper ), $( this ).find( slider_item ) );

				let swiper_related_post = new Swiper( $( this ), {
					mousewheel: {
						forceToAxis: true,
					},
					keyboard: true,
					spaceBetween: 30,
					speed: 600,
					lazy: true,
					slidesPerView: 1,
					pagination: {
						el: '[data-trigger="swiper-dots"]',
						clickable: true,
					},
					breakpoints: {
						350: {
							slidesPerView: 1.2,
							spaceBetween: 20,
						},
						650: {
							slidesPerView: 2.2,
							spaceBetween: 20,
						},
						1000: {
							slidesPerView: 3,
							spaceBetween: 20,
						},
						1381: {
							slidesPerView: 3.5,
							spaceBetween: 40,
						}
					}
				} );
			} );
		}
	}

	static wpetOffer()
	{
		const slider         = '[data-id="wpet-offer-slider"]',
			  slider_wrapper = '[data-id="wpet-offer-slider-wrapper"]',
			  slider_item    = '[data-id="wpet-offer-slider-item"]';

		let swiper_offer;

		if ( $( slider ).length > 0 ) {
			$( slider ).each( function () {

				let slider_elements = $( this ).find( slider_item );

				if ( $( slider_elements ).length > 1 ) {

					add_swiper_class( $( slider ), $( slider_wrapper ), $( slider_item ) );

					swiper_offer = new Swiper( $( this ), {
						mousewheel: {
							forceToAxis: true,
							preventClicks: false,
						},
						navigation: {
							nextEl: '[data-trigger="swiper-next"]',
							prevEl: '[data-trigger="swiper-prev"]',
						},
					} );
				}
			} );
		}
	}

}
